import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule, DatePipe } from '@angular/common';
import { RoleProvider } from './providers/role.provider';
import { NbSecurityModule, NbRoleProvider } from '@nebular/security';

import { throwIfAlreadyLoaded } from './module-import-guard';
import { DataModule } from './data/data.module';
import { UtilsModule } from './utils/utils.module';
import { AcceptLanguageInterceptor } from './interceptors';
import { PipesModule } from './pipes/pipes.module';
import { AppFormsModule } from './forms/app-forms.module';
import { accessControls } from './access-controls';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatadogErrorInterceptor } from './interceptors/DatadogError.interceptor';


export const NB_CORE_PROVIDERS = [
  { provide: HTTP_INTERCEPTORS, useClass: AcceptLanguageInterceptor, multi: true },
  {provide: HTTP_INTERCEPTORS, useClass: DatadogErrorInterceptor, multi: true},
  { provide: NbRoleProvider, useClass: RoleProvider },
  NbSecurityModule.forRoot({accessControl: accessControls }).providers,

  ...DataModule.forRoot().providers,
  ...PipesModule.forRoot().providers,
  ...AppFormsModule.forRoot().providers,
  ...UtilsModule.forRoot().providers,

  DatePipe,
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  declarations: [],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        ...NB_CORE_PROVIDERS,
      ],
    } as ModuleWithProviders<CoreModule>;
  }
}
